module.exports = __webpack_public_path__ + "img/trash.138a559d.svg";